import cn from 'classnames';
import { withBaseErrorBoundary } from '@components/error-boundaries';
import { useGetResizeRef } from '@utils/parant-site-comunicator';
import { OtpBody } from './otp-body';
import { OtpFooter } from './otp-footer';
import { otpId } from '../helpers';

import styles from '../auth-page.module.scss';

export const OtpPage = withBaseErrorBoundary(() => {
    const containerRef = useGetResizeRef();

    return (
        <div id={otpId('page')} className={styles.layout} ref={containerRef}>
            <div className="container">
                <div className={cn('rounded-box', styles.box)}>
                    <OtpBody />
                    <OtpFooter type="page" />
                </div>
            </div>
        </div>
    );
});
